import { Tag } from '..';
import type { TTagProps } from '../types/TProps';

export const TagOutlined = ({ className = '', ...props }: TTagProps) => (
  <Tag {...props} className={['tag--outlined', className].filter(Boolean).join(' ')} />
);
